"use client";

import Image from "next/image";
import { Wallet } from "lucide-react";

interface WalletInfoProps {
  balance: string | null;
  onDeposit: () => void;
  size?: "sm" | "default";
}

// Matches the Reward Hub chip's typography (Open Sauce, weight 630, tight).
const REWARD_FONT = "var(--font-open-sauce), system-ui, sans-serif";

/**
 * Branded balance unit: one dark pill holding the USDC coin + balance on the
 * left and a Deposit button nested into its right edge — a single connected
 * element, not two separate pills.
 */
export function WalletInfo({ balance, onDeposit, size = "default" }: WalletInfoProps) {
  const formattedBalance = balance ? `${parseFloat(balance).toFixed(2)} USD.P` : "Loading...";
  const isSmall = size === "sm";

  return (
    <div
      style={{ fontFamily: REWARD_FONT }}
      className={`
        flex items-center rounded-full bg-grey-800 ring-1 ring-inset ring-grey-700
        ${isSmall ? "gap-2 py-1 pl-2.5 pr-1" : "gap-3 py-1 pl-3 pr-1"}
      `}
    >
      <Image
        src="/images/usdc.svg"
        alt="USDC"
        width={isSmall ? 18 : 22}
        height={isSmall ? 18 : 22}
        className={`shrink-0 ${isSmall ? "size-[18px]" : "size-[22px]"}`}
      />
      <span className={`font-[630] tracking-tight tabular-nums text-white ${isSmall ? "text-xs" : "text-sm"}`}>
        {formattedBalance}
      </span>
      <button
        onClick={onDeposit}
        className={`
          flex items-center gap-1.5 rounded-full bg-primary font-[630] tracking-tight text-white
          transition-colors hover:bg-primary/90
          ${isSmall ? "px-3 py-1.5 text-xs" : "px-4 py-2 text-sm"}
        `}
      >
        <Wallet className={isSmall ? "size-3.5" : "size-4"} />
        Deposit
      </button>
    </div>
  );
}
